import $ from 'jquery';

import Calendar from '../../collection/calendar';
import Filters from '../../view/module/schedule/launch.filters';
import Runs from '../../collection/schedule/runs';
import Module from '../../core/module';
import ScheduleCalendarModule from './calendar';
import ScheduleTasksModule from './tasks';
import ScheduleCardTemplatesModule from './templates.list';
import Stats from '../../collection/schedule/stats';
import ScheduleFormModule from './form';

import { pst, del } from '../../http/api';
import { fmt, unixts, datify, beginDay, endDay } from '../../utils/date';
import { ask, } from '../../utils/popups';
import { beginLock, endLock } from '../../loader';
import { Collection } from 'backbone';





export default Module.extend( {

    template: 'jst/module.schedule.runs',

    url() {
        return `schedule/runs/${fmt( this.options.date, 'YYYY-MM-DD' )}`;
    },

    open(month, date) {
        this.options.date = date;
        
        this.setState( { month: unixts( datify( month ) ), } );
        if (!this.state().page)
            this.setState( { page: 1, } );

        this.options.calendar = new Calendar( this.state().month );
        this.options.stats = new Collection();
        this.options.runs = new Runs( [] );
        
        return this.filtersModel = new Filters.Model( this.state().filters ),
            this.lastFiltering_ = Promise.resolve(),
            this.postpone( fetchRuns, fetchCalendar )
                .then( () => this.bind( this.filtersModel ) );
    },

    start() {
        return this;
    },

    stop() {
        return this;
    },

    serialize() {
        const { date } = this.options;

        return {
            date, 
            stats: this.options.stats,
        };
    },

    events: {

        'click .-new-schedule': function({currentTarget}) {
            this.trigger( ScheduleFormModule.POPUP_NEW );
        },

        'click .-toggle-monthly'() {
            this.trigger( ScheduleCalendarModule.TOGGLE_CALENDAR,
                undefined,
                undefined,
                this.state().month,
                this.options.date,
                this.state().filters );
        },

        'click .-toggle-list'() {
            this.trigger( ScheduleCalendarModule.TOGGLE_LIST_VIEW, 
                datify( this.state().month ),
                this.options.date,
                this.state().filters );
        },
            
    },

    [Module.event( ':schedule:edit' )]({ id }) {
        return this.trigger( ScheduleFormModule.POPUP_EDIT, 
            // pass id only to force Schedule.byId in Form
            id );
    },

    [Module.event( ':schedule:delete' )]({ id }) {
        return ask( 'schedule::modal delete schedule - confirmation text', 
            'schedule::modal delete schedule - title', 
            'actions::yes', 
            'actions::no',
            () => del( `/timetables/${id}` )
                .blocking( this ).cerebellum()
                .execute() )
            .then( () => beginLock( this ) )
            .then( () => this.postpone( fetchRuns, fetchCalendar ) )
            .then( () => {
                if (this.options.runs.total > 0 && !this.options.runs.length)
                    if (this.state().page > 1)
                        return this.setState( { page: this.state().page - 1, } ),
                            this.postpone( fetchRuns, fetchCalendar );
            } )
            .then( () => this.render() )
            .then( () => endLock( this ), () => endLock( this ) )
            .then( () => this.navigated() );
        },

    [Module.event( 'Runs:run:restart' )](attrs, dateStr, timeStr, e) {
        const datetime = datify( `${dateStr} ${timeStr}:00` );
        return pst( `/timetables/${attrs.id}/restart/${fmt( datetime, 'YYYY-MM-DD/@/HH-mm' )}?apiVersion=2.0` )
            .blocking( this ).cerebellum()
            .execute()
            .then( () => {
                this.$( e.currentTarget ).remove();
                beginLock();
                location.reload();
            } )
            .catch( () => ask( 'errors::common notification',
                'errors::common notification',
                'actions::close' ) );
    },

    [Module.event( 'Runs:schedule:pin' )]({ id }, time) {
        return this.trigger( ScheduleTasksModule.REPLACE, 
            // pass id only; schedule will be retrieved by /tasks response
            id,
            time,
            this.state().month,
            this.options.date,
            this.state().filters );    
    },

    [Module.event( ':schedule:templates' )]({ id }) {
        return this.trigger( ScheduleCardTemplatesModule.POPUP, 
            // pass id only to force Schedule.byId in Template List
            id );
    },

    [Module.event( 'Filters:change' )](filters) {
        this.setState( { filters, page: 1, } );
        
        return this.postpone( fetchRuns, fetchCalendar )
            .then( () => Promise.all( [this.Calendar.render(), this.Runs.render(), this.Paging.render()] ) )
            .then( () => this.navigated() )
            .then( () => $( window ).scrollTop( 0 ) );
    },

    [Module.event( 'Paging:page' )](page) {
        return this.setState( { page: +page, } ),
            beginLock( this ),
            this.postpone( fetchRuns )
                .then( () => this.Runs.render() )
                .then( () => endLock( this ) ) 
                .then( () => this.navigated() );
    },

    [Module.event( 'Calendar:set-month' )](month) {
        return this.options.calendar.set( month ),
            this.setState( { month: unixts( this.options.calendar.getMonth() ) } ),
            this.postpone( fetchCalendar )
                .then( () => this.Calendar.render() )
                .then( () => this.navigated() );
    },

    [Module.event( 'Calendar:date:toggle' )](date) {
        return this.options.date = date,
            this.setState( { page: 1, } ),
            this.postpone( fetchRuns )
                .then( () => this.render() )
                .then( () => this.navigated() );
    },

    postpone(...fetchFunctions) {
        return this.lastFiltering_ = this.lastFiltering_.then( 
            () => Promise.all( 
                fetchFunctions.map( fn => fn.call( this  ) ) ) );
    },

} );





function fetchRuns() {
    const
        { date } = this.options,
        { page } = this.state();

    const dailyFilters = {
        date,
        limit: 12,
        page,
        ...this.filtersModel.values(),
    };

    return this.options.runs.filter( dailyFilters );
}

function fetchCalendar() {
    const filters = { ...this.filtersModel.values() };
        
    const collection = new Stats( { calendar: this.options.calendar, } );
    return collection.filter( filters ).then( 
        ([items/*, coll*/]) => this.options.stats.reset( items ) );
}


// WEBPACK FOOTER //
// ./src/js/module/schedule/runs.js